import { useMemo, useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Navbar from "./components/shared/Navbar";
import MobileBottomNav from "./components/shared/MobileBottomNav";


const PrivateRoute = ({ userData }) => {
  const isAuthenticated = useMemo(() => {
    return (userData, accessToken) => {
      return userData && accessToken;
    };
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("profile");
  const accessToken = JSON.parse(token)?.accessToken;


  useEffect(() => {
    if (!isAuthenticated(userData, accessToken)) {
      navigate("/auth");
    }
  }, [dispatch, navigate, userData, accessToken, isAuthenticated]);



  return isAuthenticated(userData, accessToken) ? (
    <div className="scroll-smooth">
      <Navbar
        userData={userData}
      />

      <div className="mx-auto w-full md:w-[99%] mt-2 md:mt-3 px-2 md:px-0 pb-20 md:pb-0">
        <div className="mt-1 md:mt-1 min-h-[85vh]">
          <Outlet />
        </div>
      </div>
      
      <MobileBottomNav user={userData} />
    </div>
  ) : (
    <Navigate to="/auth" />
  );
};

export default PrivateRoute;
